import React from 'react';

import MultiViewGestioneLicenze from './../containers/gestione_licenze/MultiViewGestioneLicenze';
import ToolbarGestioneLicenze from './../containers/gestione_licenze/ToolbarGestioneLicenze';

import EstendiLicenza from './../containers/gestione_licenze/EstendiLicenza';
import GestioneStatoLicenza from './../containers/gestione_licenze/GestioneStatoLicenza';
import DisassociaLicenza from './../containers/gestione_licenze/DisassosociaLicenza';


class GestioneLicenze extends React.Component {

    render() {
        return (
            <React.Fragment>
                <h2 className={'content-block'}>Gestione Licenze</h2>
                <ToolbarGestioneLicenze />

                <MultiViewGestioneLicenze />

                <EstendiLicenza />
                <GestioneStatoLicenza />
                <DisassociaLicenza />
            </React.Fragment>
        );
    }
};


export default GestioneLicenze;